import React, { useState, useEffect, useRef } from "react";
import { NavLink } from 'react-router-dom';
import "./FixedNavbar.css";
import { Nav, Navbar as BootstrapNavbar } from "react-bootstrap";
import logo from "./assets/logo.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLocation } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const FixedNavbar = () => {
    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const [ishowtoOpen, setIshowtoOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const location = useLocation();


    const navbarRef = useRef(null);
    const [isLoggedIn, setIsLoggedIn] = useState(!!window.localStorage.getItem("token"));

    useEffect(() => {
        const navbar = navbarRef.current;
        if (!navbar) return;

        gsap.set(navbar, { y: -150, opacity: 0 });

        const animation = gsap.to(navbar, {
            y: 0,
            opacity: 1,
            duration:2.5,
ease: "back.out(1.7)",
            scrollTrigger: {
                trigger: "body",
                start: "top top",
                end: "+=250",
                toggleActions: "play none none reverse",
                markers: false,
            }
        });

        return () => {
            animation.scrollTrigger?.kill();
        };
    }, [location.pathname]);  // 👈 depend on location.pathname

    const handleAboutMouseEnter = () => setIsAboutOpen(true);
    const handleAboutMouseLeave = () => setIsAboutOpen(false);
    const handleAboutClick = () => setIsAboutOpen((prev) => !prev);

    const handleHowtoMouseEnter = () => setIshowtoOpen(true);
    const handleHowtoMouseLeave = () => setIshowtoOpen(false);
    const handleHowtoClick = () => setIshowtoOpen((prev) => !prev);

    const handleServicesMouseEnter = () => setIsServicesOpen(true);
    const handleServicesMouseLeave = () => setIsServicesOpen(false);
    const handleServicesClick = () => setIsServicesOpen((prev) => !prev);

    return (
        <BootstrapNavbar ref={navbarRef} fixed="top" className="fixed-nav shadow-sm py-2" expand="md">
            <div className="container">
                <NavLink to="/" className="navbar-brand">
                    <img src={logo} alt="Logo" className="logo" />
                </NavLink>
                <BootstrapNavbar.Toggle aria-controls="fixed-navbar-nav" />
                <BootstrapNavbar.Collapse id="fixed-navbar-nav">
                    <Nav className="me-auto">
                        <NavLink to="/" className="nav-link">Home</NavLink>

                        <Nav.Item
                            className="nav-item nav-dropdown"
                            onMouseEnter={handleAboutMouseEnter}
                            onMouseLeave={handleAboutMouseLeave}
                            onClick={handleAboutClick}
                        >
                            <NavLink className="nav-link">
                                About Us
                            </NavLink>
                            <div className={`dropdown-menu ${isAboutOpen ? "show" : ""}`}>
                                <NavLink to="/about-us/company-profile" className="dropdown-item">
                                    Company Profile
                                </NavLink>
                            </div>
                        </Nav.Item>

                        <NavLink to="/inventory" className="nav-link">Inventory</NavLink>

                        <NavLink to="/bank-details" className="nav-link">Bank Details</NavLink>

                        <Nav.Item
                            className="nav-item nav-dropdown"
                            onMouseEnter={handleServicesMouseEnter}
                            onMouseLeave={handleServicesMouseLeave}
                            onClick={handleServicesClick}
                        >
                            <NavLink className="nav-link">
                                Services
                            </NavLink>
                            <div className={`dropdown-menu ${isServicesOpen ? "show" : ""}`}>
                                <NavLink to="/services/how-to-buy" className="dropdown-item">
                                    How to Buy
                                </NavLink>
                                <NavLink to="/services/customer-review" className="dropdown-item">
                                    Car Reviews
                                </NavLink>
                                <NavLink to="/services/faq" className="dropdown-item">
                                    FAQ
                                </NavLink>
                            </div>
                        </Nav.Item>

                        <NavLink to="/contact" className="nav-link">Contact Us</NavLink>

                    </Nav>

                    <Nav>

                        <NavLink to="/" className="nav-link text-purple-600 heartbox">
                            <i className="bi bi-heart-fill"></i> Saved
                        </NavLink>

                        <NavLink to={isLoggedIn ? "/admin-panel" : "/sign-in"} className="nav-link">
                            {isLoggedIn ? "Dashboard" : "Sign In"}
                        </NavLink>

                    </Nav>
                </BootstrapNavbar.Collapse>
            </div>
        </BootstrapNavbar>
    );
};

export default FixedNavbar;